export default class ReportType {
    public static None: number = 0;
    public static TeamMatchReport: number = 1;
    public static PlayerMatchReport: number = 2;
    public static TeamMatchScoreSummary: number = 3;
    public static TeamSeasonReport: number = 4;
    public static PlayerSeasonReport: number = 5;
    public static TeamSeriesReport: number = 6;
    public static PlayerSeriesReport: number = 7;
}